import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "Faculty";

export const getFacultiesUrl = (studentTpeId) =>
	`${baseUrl}/${studentTpeId}/faculties`;
export const getAllDeansUrl = (filter) =>
	`${baseUrl}/deans?${generateUrlParams(filter)}`;
export const assignDeantoFacultyUrl = () => `${baseUrl}/assign-dean-to-faculty`;

export const getFaultyDepartmentsUrl = (applicationTypeId) =>
	`${baseUrl}/${applicationTypeId}/application-faculty`;

export const bulkFacultiesUploadUrl = () => `${baseUrl}/upload-faculties`;
export const createFacultyUrl = () => `${baseUrl}/create-faculty`;
export const deleteFacultyUrl = (id) =>
	`${baseUrl}/delete-faculty?facultyId=${id}`;
export const downloadFacultyExcelTemplateUrl = () =>
	`${baseUrl}/download-faculty-upload-template`;
export const getAllPaginatedFacultiesUrl = (filter) =>
	`${baseUrl}/all-faculties-paginated?${generateUrlParams(filter)}`;
export const toggleFacultyActivationStatusUrl = (id) =>
	`${baseUrl}/faculty/${id}/toggle-activation`;
export const updateFacultyUrl = () => `${baseUrl}/update-faculty`;
